export const WHATSAPP_NUMBER = "+9779813762963"; 
// UPDATED: Microsoft Teams Community Link
export const TEAMS_LINK = "https://teams.live.com/l/community/FEA1RPd3_XyysB1RAE"; 
export const LINKEDIN_URL = "https://linkedin.com/in/mohankrishnakarki";
export const EMAIL_ADDRESS = "hello@mohanworkspace.com";


// --- NEW GEMINI API CONFIG ---
export const API_KEY = "AIzaSyDiJTwoIudUbrb5noQ-iBWBU_J4Wrmq4EA"; // Canvas will automatically provide the API key
export const MODEL = "gemini-2.5-flash-preview-09-2025";
export const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/${MODEL}:generateContent?key=${API_KEY}`;
